import styled from 'styled-components';

import { alignMiddle } from '../../../styles/utils/positioning';

export const ComponentContainer = styled.div`
  position: relative;
`;

export const ResetBtn = styled.button`
  position: absolute;
  right: 0px;
  background-color: ${({ theme }) => theme.background};
  ${alignMiddle}

  .iconCrossInCircle {
    color: ${({ theme }) => theme.background};
    fill: ${({ theme }) => theme.baseBlue.a7};
  }
`;

export const Container = styled.div<{ $maxWidth: string }>`
  cursor: pointer;
  max-width: ${({ $maxWidth }) => $maxWidth};

  .date-range-selector {
    cursor: pointer;

    .ant-picker-input {
      color: ${({ theme }) => theme.baseBlue.a10};

      input,
      input::placeholder {
        color: ${({ theme }) => theme.baseBlue.a10};
        font-weight: 600;
        font-size: 0.8rem;
        text-transform: uppercase;
        cursor: pointer;
        text-align: right;
      }

      input {
        width: 50%;
        height: 100%;
        text-align: center;
      }

      .ant-calendar-picker-clear {
        width: 15px;
        height: 15px;
        color: ${({ theme }) => theme.baseBlue.a7};
        right: -25px;
        background: ${({ theme }) => theme.background};
        margin-top: -8px;
        opacity: 1;

        &:hover {
          color: ${({ theme }) => theme.baseBlue.a10};
        }

        svg {
          width: 100%;
          height: 100%;
        }
      }
    }

    .ant-picker-suffix {
      display: none;
    }
  }
  &.is-empty {
    .date-range-selector {
      .ant-picker-input {
        input {
          width: 100%;
        }
      }
    }
  }

  .is-input {
    div:not(:first-child) {
      display: none;
    }
  }
`;
